var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"key-component":_vm.keyComponent,"component-data":_vm.componentData,"is-input-field":_vm.isInputField},on:{"updated":function($event){return _vm.$emit('updated')}}})}
var staticRenderFns = []

export { render, staticRenderFns }